import { useContext } from 'react';
import { ConfigContext } from './ConfigDataProvider';

// ==============================|| CONFIG - HOOKS  ||============================== //

const useConfigContext = () => useContext(ConfigContext);

export default useConfigContext;
